/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Loader2 = [
  "svg",
  defaultAttributes,
  [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56" }]]
];

export { Loader2 as default };
//# sourceMappingURL=loader-2.js.map
